// ABOUTME: Calls the dedicated MCP panel API using the user's existing Cognito login.
// ABOUTME: Keeps consent tickets out of browser storage and confines requests to the configured origin.
import { Auth } from "aws-amplify";
async function mcpPanelRequest(
    path: string,
    body: Record<string, unknown>,
    signal?: AbortSignal
): Promise<Response> {
    const origin = new URL(import.meta.env.VITE_MCP_API_ORIGIN);
    if (
        origin.protocol !== "https:" ||
        origin.pathname !== "/" ||
        origin.username ||
        origin.password ||
        origin.search ||
        origin.hash ||
        !/^\/panel\/mcp\/[a-z/]+$/.test(path)
    )
        throw new Error("MCP unavailable");
    const token = (await Auth.currentSession()).getIdToken().getJwtToken();
    const response = await fetch(new URL(path, origin), {
        method: "POST",
        credentials: "omit",
        cache: "no-store",
        referrerPolicy: "no-referrer",
        signal,
        headers: {
            authorization: `Bearer ${token}`,
            "content-type": "application/json"
        },
        body: JSON.stringify(body)
    });
    if (!response.ok) throw new Error("MCP request unavailable");
    return response;
}
export async function mcpPanelCall<T>(
    path: string,
    body: Record<string, unknown>,
    signal?: AbortSignal
): Promise<T> {
    return (await mcpPanelRequest(path, body, signal)).json();
}
export async function mcpPanelDownload(fileId: string) {
    const response = await mcpPanelRequest("/panel/mcp/download", { fileId });
    const match = response.headers
        .get("content-disposition")
        ?.match(/filename\*=UTF-8''([^;]+)/);
    const filename = match
        ? decodeURIComponent(match[1]).replace(/[\x00-\x1f\x7f/\\]/g, "_")
        : "download";
    const url = URL.createObjectURL(await response.blob());
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = filename;
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
    window.setTimeout(() => URL.revokeObjectURL(url), 1000);
}
export function followMcpConsentRedirect(value: string) {
    const target = new URL(value);
    const issuer = new URL(import.meta.env.VITE_MCP_ISSUER);
    if (
        issuer.protocol !== "https:" ||
        target.origin !== issuer.origin ||
        !/^\/interaction\/[A-Za-z0-9_-]{1,256}\/(complete|cancel)$/.test(
            target.pathname
        ) ||
        target.username ||
        target.password ||
        target.hash
    )
        throw new Error("Invalid consent destination");
    window.location.assign(target.href);
}
